import { type ChangeEvent, useEffect, useState } from 'react'

import { onCheckDisabledConditions } from '@/app/utils'

interface IField {
    name: string
    value: string
    placeholder: string
    error: string | null
    isTouched: boolean
}

export const useFields = () => {
    const initialOldPassword: IField = {
        name: 'oldPassword',
        value: '',
        placeholder: 'Старый пароль',
        error: null,
        isTouched: false
    }

    const initialNewPassword: IField = {
        name: 'newPassword',
        value: '',
        placeholder: 'Новый пароль',
        error: null,
        isTouched: false
    }
    const [oldPassword, setOldPassword] = useState<IField>(initialOldPassword)
    const [newPassword, setNewPassword] = useState<IField>(initialNewPassword)

    useEffect(() => {
        if (!oldPassword.value.length) {
            setOldPassword((prev) => ({ ...prev, error: 'Обязательное поле' }))
        } else if (
            !/^(?=.*\d)(?=.*[a-z])(?=.*[A-Z])(?=.*[!@#$;^&*])[0-9a-zA-Z!@#$;^&*]{8,25}$/g.test(oldPassword.value)
        ) {
            setOldPassword((prev) => ({ ...prev, error: 'Пароль не валиден' }))
        } else {
            setOldPassword((prev) => ({ ...prev, error: null }))
        }

        if (!newPassword.value.length) {
            setNewPassword((prev) => ({ ...prev, error: 'Обязательное поле' }))
        } else if (
            !/^(?=.*\d)(?=.*[a-z])(?=.*[A-Z])(?=.*[!@#$;^&*])[0-9a-zA-Z!@#$;^&*]{8,25}$/g.test(newPassword.value)
        ) {
            setNewPassword((prev) => ({ ...prev, error: 'Пароль не валиден' }))
        } else {
            setNewPassword((prev) => ({ ...prev, error: null }))
        }
    }, [oldPassword.value, newPassword.value])

    const onHandleChangeOld = (e: ChangeEvent<HTMLInputElement>) =>
        setOldPassword((prev) => ({ ...prev, value: e.target.value }))

    const onHandleChangeNew = (e: ChangeEvent<HTMLInputElement>) =>
        setNewPassword((prev) => ({ ...prev, value: e.target.value }))

    const onHandleFocusNew = () => setNewPassword((prev) => ({ ...prev, isTouched: true }))

    const onHandleFocusOld = () => setOldPassword((prev) => ({ ...prev, isTouched: true }))

    const onZeroOld = () => setOldPassword((prev) => ({ ...prev, value: '' }))
    const onZeroNew = () => setNewPassword((prev) => ({ ...prev, value: '' }))

    const onInitializeFields = () => {
        setOldPassword(initialOldPassword)
        setNewPassword(initialNewPassword)
    }

    const oldPasswordError = oldPassword.isTouched && oldPassword.error ? oldPassword.error : null
    const newPasswordError = newPassword.isTouched && newPassword.error ? newPassword.error : null

    const isValidFields = onCheckDisabledConditions(
        Boolean(!oldPassword.error),
        Boolean(oldPassword.isTouched),
        Boolean(!newPassword.error),
        Boolean(newPassword.isTouched)
    )

    return {
        oldPassword,
        oldPasswordError,
        onHandleChangeOld,
        onHandleFocusOld,
        onZeroOld,
        newPassword,
        newPasswordError,
        onHandleChangeNew,
        onHandleFocusNew,
        onZeroNew,
        isValidFields,
        onInitializeFields
    }
}
